import { saveAs } from 'file-saver';

export const exportToCSV = (jsonData, fileName = 'data.csv', options = {}) => {

    if (!jsonData || jsonData.length === 0) {        
        return false;
      }

    const { delimiter = ',', includeHeaders = true } = options;

    // Replacer function to handle null values and other cases if needed
    const replacer = (key, value) => value === null ? '' : value;

    // Extract headers from the first object if headers are to be included
    const headers = includeHeaders ? Object.keys(jsonData[0]) : [];

    // Create CSV content
    const csvContent = jsonData.map(row =>
        headers.map(field => {
            const cell = JSON.stringify(row[field], replacer);
            // Remove quotes added by JSON.stringify
            const cleanedCell = cell === undefined ? '' : cell.replace(/(^"|"$)/g, '').replace(/"/g, '""');
            // Wrap cell in quotes if it contains a delimiter, newline, or quote
            return cleanedCell.search(/,|\n|"/) >= 0 ? `"${cleanedCell}"` : cleanedCell;
        }).join(delimiter)
    );

    // Add headers to CSV content if required
    if (includeHeaders) {
        csvContent.unshift(headers.join(delimiter));
    }

    // Convert the CSV content to a Blob and trigger the download
    const blob = new Blob([csvContent.join('\n')], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, fileName);
    return true;
};
